module.exports = __webpack_public_path__ + "static/media/handle-green.3d1deffa.png";